import type { AppLanguage } from "@/constants/i18n";
import { EXTERNAL_LINKS } from "@/constants/navigation";

/** E.164 phone for `tel:` links. */
export const CONTACT_PHONE = "+79932830721";

export const CONTACT_EMAIL = "info@genesis-corporation.ru";
export const EXORDOS_CONTACT_EMAIL = "info@exordos.com";
export const EXORDOS_CONTACT_LINKS = {
  email: `mailto:${EXORDOS_CONTACT_EMAIL}`,
} as const;

export const CONTACT_LINKS = {
  email: `mailto:${CONTACT_EMAIL}`,
  phone: `tel:${CONTACT_PHONE}`,
} as const;

export function getCompanyUrl(language: AppLanguage): string {
  return `${EXTERNAL_LINKS.company}/${language}`;
}

export function getCompanyAboutUrl(language: AppLanguage): string {
  return `${getCompanyUrl(language)}#about`;
}

export function getCompanyContactsUrl(language: AppLanguage): string {
  return `${getCompanyUrl(language)}#contacts`;
}
